import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { settings } from '../DealSlider/DealSlider';
import Product from './Product';
import { Box, Typography, Button, useTheme } from '@mui/material';

const ProductSlider = ({ title, tagline, products, loading, emptyMessage = "No products to display." }) => {
    const theme = useTheme();

    return (
        <Box sx={{
            backgroundColor: theme.palette.background.paper,
            width: '100%',
            boxShadow: 3,
            overflow: 'hidden',
            borderRadius: 2,
            my: 4
        }}>
            <Box sx={{
                display: 'flex',
                px: 3,
                py: 2,
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: `1px solid ${theme.palette.divider}`
            }}>
                <Box>
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>{title}</Typography>
                    <Typography variant="body2" color="text.secondary">{tagline}</Typography>
                </Box>
                <Button component={Link} to="/products" variant="contained" color="primary" sx={{ textTransform: 'uppercase', boxShadow: 'lg' }}>
                    View All
                </Button>
            </Box>
            {loading ? null : (
                products && products.length > 0 ? (
                    <Slider {...settings} className="flex items-center justify-between p-1">
                        {products.map((product) => (
                            product && <Product {...product} key={product._id} />
                        ))}
                    </Slider>
                ) : (
                    <Typography variant="h6" align="center" sx={{ p: 3 }}>
                        {emptyMessage}
                    </Typography>
                )
            )}
        </Box>
    );
};

export default ProductSlider;
